export default {
  setFilters: ({ commit }, filters) => {
    commit('filters', filters)
  },

  editFilters: ({ commit, state }, filter) => {
    commit('editFilters', {...state.filters, filter})
  }

}




// WEBPACK FOOTER //
// ./src/store/actions/filters.js